


import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import "./CustomDropdownMui.css";
import "../ComponentsCss/componet.css";
import { InputAdornment, InputLabel, Typography } from "@mui/material";
import { Field, ErrorMessage } from "formik";
import { Email } from "@mui/icons-material";
import { FaStarOfLife } from "react-icons/fa6";

const CustomDropdownMui = ({
  label,
  name,
  options,
  custPlaceholder,
  isDashboard,
  setFieldValue,
  selectmovieIdfn,
  selectCategoryIdfn,
  important,
  onChange,
  assignOpreatorToCustomerFn,
  customerId,
  image,
  ...rest
}) => {
  return (
    <div style={{ width: "100%" }}>
      {label && (
        <div style={{ marginBottom: "4px" }}>

          <Typography variant={isDashboard ? "subtitle2" : "subtitle1"} sx={{
            color: isDashboard ? "black" : "gray",

            fontSize: "15px",
            mb: 1
          }}>

            {label}

            {important && (
              <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px" }} />
            )}
          </Typography>
        </div>
      )}

      <div style={{ position: "relative", width: "100%" }}>

        <div
          style={{
            position: "absolute",

            top: "55%",
            left: "10px",
            transform: "translateY(-50%)",
            color: "black",
          }}
        >
          <img src={image} style={{ height: "17px" }}></img>
        </div>
        <Field name={name}>
          {({ field, form }) => (
            <select
              id={name}
              {...field}
              {...rest}
              className="customDropdown-input"
              style={{
                borderRadius: "3px",
                width: "100%",
                color: "#7A7A7A",
                height: "40px",
                // paddingLeft: "40px", // Add padding to avoid overlapping with the icon
                boxSizing: "border-box",
                paddingLeft: "10px"
              }}
              onChange={(e) => {
                const selectedValue = e.target.value;
                // const selectedOption = options.find(option => option.value === selectedValue);
                // const selectedId = selectedOption ? selectedOption.id : null;

                form.setFieldValue(name, selectedValue); // Update Formik state

                if (onChange) {
                  onChange(selectedValue); // Send value and ID to parent
                }
              }}

            >
              {custPlaceholder && (
                <option value="" disabled className="customDropdown-disabled-option">
                  {custPlaceholder ? custPlaceholder : "Select dropdown"}
                </option>
              )}
              {options?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        </Field>
      </div>

      <ErrorMessage name={name} component="div" className="inputs-error-msg"
        style={{ color: "red", fontSize: "12px", fontWeight: '400' }}
      />
    </div >
  );
};

export default CustomDropdownMui;
